itsoftApp.createModule("loadItemsWithFilters", function () {
    const module = this;

    const initLoad = function (section) {  
        const filters = section.querySelector(".js-filters"); //
        const sorting = section.querySelector(".js-sorting"); //
        const loadTarget = section.querySelector(".js-load-target");
        const loadTrigger = section.querySelector(".js-load");
        let loadTriggerParent;
        let url;

        let filtersInited = false; //

        if (loadTrigger) {
            loadTriggerParent = section.querySelector(".js-load-parent") || loadTrigger.parentNode;
        }

        let pagination = section.querySelector(".js-pagination"); ///
        let paginationParent;
 
        if (pagination) {
            paginationParent = pagination.parentNode; ///
        }

        const sendRequest = function (onSuccess, onError, flag, withFilters) {
            const xhr = new XMLHttpRequest();

            xhr.addEventListener("load", function () {
                if (xhr.status === 200 && onSuccess) {
                    if (flag) {
                        onSuccess(xhr.response, flag);
                    }
                } else {
                    onError(xhr.response);
                }
            });

            xhr.addEventListener("error", function () {
                onError("Произошла ошибка соединения");
            });
            xhr.addEventListener("timeout", function () {
                onError("Запрос не успел выполниться за " + xhr.timeout + "мс");
            });

            xhr.timeout = 10000;

            if (withFilters) {
                DEBUG && console.log('YES, with filters');
                /* Повторяется из модуля filters */
                const filtersSection = section;
                const filtersForm = filtersSection.querySelector(".js-filters");
                const exIds = filtersForm.querySelector("[name='ex_ids']");
                const filtersBlocks = filtersSection.querySelectorAll(".js-filter-block");

                let allFiltersValues = [];

                allFiltersValues = Array.prototype.map.call(filtersBlocks, function (filterBlock) {
                    const allFiltersItems = filterBlock.querySelectorAll(".js-filter-item") || [];
                    const allCheckedFilters = Array.prototype.filter.call(allFiltersItems, item => item.checked) || [];
                    
                    return {
                    name: filterBlock.getAttribute("name") || filterBlock.getAttribute("data-name") || allCheckedFilters[0].name,
                    value: Array.prototype.map.call(allCheckedFilters, (checkedFilter) => checkedFilter.value)
                    }
                });

                url += "?";

                Array.prototype.forEach.call(allFiltersValues, function (filterValue, index, arr) {
                    const selectName = filterValue.name;
                    const selectValue = filterValue.value.join(';');
    
                    url += selectName + "=" + selectValue;
    
                    if (index < arr.length - 1) {
                      url += '&';
                    }
                });

                if (exIds) {
                    url += '&';
                    url += exIds.name + "=" + exIds.value;
                }

                url.replace(/\s/g, '+');
            }

            /* */

            xhr.open("GET", url);
            xhr.send();
        };

        const onErrorLoad = function (data) {
            console.log("error ", data);
        };

        const removeOldDataFromPage = function () {
            const cards = loadTarget.querySelectorAll(".js-load-item");

            for (var i = 0; i < cards.length; i++) {
                cards[i].parentNode.removeChild(cards[i]);
            }
        }

        const removeOldNavFromPage = function () {
            pagination = section.querySelector(".js-pagination");

            if (pagination) {
                paginationParent.removeChild(pagination);
            }
        }

        const addNewDataToPage = function (wrapper) {
            const newElements = wrapper.querySelectorAll(".js-load-item");  //  Ищем элементы

            if (newElements.length > 0) {
                const fragment = document.createDocumentFragment();

                /*** ***/
                const isAccordion = wrapper.querySelector(".js-accordion");

                if (isAccordion) {
                    new itsoftApp.modules.accordion.callback(isAccordion);
                }

                /*** ***/

                Array.prototype.forEach.call(newElements, function (newElement) {
                    fragment.appendChild(newElement);
                });

                loadTarget.appendChild(fragment);
            }
        }

        const addNewNavToPage = function (wrapper) {
            const newPagination = wrapper.querySelector(".js-pagination");//  Ищем навигацию
            const newLoadTrigger = wrapper.querySelector(".js-load"); // Ищем кнопку для загрузки доп. элементов

            if (newPagination) {
                const newPaginationLinks = newPagination.querySelectorAll(".js-pagination-link");

                if (newPaginationLinks.length > 0) {
                    Array.prototype.forEach.call(newPaginationLinks, function (newPaginationLink) {
                        if (newPaginationLink.hasAttribute("href")) {
                            newPaginationLink.addEventListener("click", onTogglePageClick);
                        }
                    });
                }

                paginationParent.appendChild(newPagination);
            }

            if (newLoadTrigger && loadTriggerParent) {
                if (loadTriggerParent.classList.contains("g-hidden")) {
                    loadTriggerParent.classList.remove("g-hidden")
                }

                loadTrigger.href = newLoadTrigger.href;
            } else {
                if (loadTriggerParent) {
                    loadTriggerParent.classList.add("g-hidden");
                } else {
                    /* TODO: сделать возможность добавления кнопки, если изначально её не было */
                }
            }
        }

        const onSuccessToggle = function (data, scrolling) {
            const wrapper = document.createElement("div");
            wrapper.innerHTML = data;

            removeOldDataFromPage();
            removeOldNavFromPage();
            addNewDataToPage(wrapper);
            addNewNavToPage(wrapper);

            // if (scrolling) {
            //     itsoftApp.modules.animateScroll.callback(loadTarget, null, 500, 500, "easeInOutQuad", 15);
            // }
        };

        const onSuccessLoad = function (data) {
            const wrapper = document.createElement("div");
            wrapper.innerHTML = data;

            removeOldNavFromPage();
            addNewDataToPage(wrapper);
            addNewNavToPage(wrapper);
        };

        const onLoadTriggerClick = function (evt) {
            evt.preventDefault();
            const button = evt.currentTarget;
            url = button.getAttribute("href");

            if (loadTrigger.classList.contains("js-load-with-filters")) {
                sendRequest(onSuccessLoad, onErrorLoad, true, true);
            } else {
                sendRequest(onSuccessLoad, onErrorLoad, true);
            }
        };

        const onTogglePageClick = function (evt, urlRequest) {
            let button = null;

            if (evt) {
                evt.preventDefault();
                button = evt.currentTarget;
            }
            
            if (!urlRequest && button) {
                url = button.getAttribute("href") || button.getAttribute("data-href");
            } else {
                url = urlRequest;
            }

            sendRequest(onSuccessToggle, onErrorLoad, true);
        }

        const onSortingBtnClick = function (evt, urlRequest) {
            evt.preventDefault();
            const button = evt.currentTarget;
            button.classList.toggle("js-toggle-active");
            /* ??? */
            if (!urlRequest && button) {
                url = button.getAttribute("data-href");
            } else {
                url = urlRequest;
            }
        }

        if (loadTrigger) {
            loadTrigger.addEventListener("click", onLoadTriggerClick);
        }

        if (pagination) {
            const paginationLinks = section.querySelectorAll(".js-pagination-link");

            if (paginationLinks.length > 0) {
                Array.prototype.forEach.call(paginationLinks, function (paginationLink) {
                    if (paginationLink.hasAttribute("href")) {
                        paginationLink.addEventListener("click", onTogglePageClick);
                    }
                });
            }
        }

        if (sorting) {
            const sortingButtons = section.querySelectorAll(".js-sorting-btn");

            if (sortingButtons.length > 0) {
                Array.prototype.forEach.call(sortingButtons, function (sortingBtn) {
                    if (sortingBtn.hasAttribute("data-href")) {
                        sortingBtn.addEventListener("click", onSortingBtnClick);
                    }
                });
            }
        }

        if (filters && !filtersInited) {
            filtersInited = true;
            itsoftApp.modules.filters.init(section, onTogglePageClick);
        }
    };


    module.initLoad = initLoad;
});